import React from 'react'
import { Deal } from '../models/shared/Deal';
import { DEFAULT_TAGS, TagDefinition } from '../models/shared/TagDefinition';
import { useOrganization } from '../context/OrganizationContext';

interface Props {
    deal: Deal;
    onClick?: () => void;
    className?: string;
}

export default function Tags(props: Props) {
    const { organization } = useOrganization();
    const allTags = organization.tags || DEFAULT_TAGS;
    const tags = props.deal.tags || [];
    const orderedTags = allTags.filter(tag => tags.includes(tag.id)).map(tag => tag.id);

    const allTagRecord: Record<string, TagDefinition> = {};
    for (const tag of allTags) {
        allTagRecord[tag.id] = tag;
    }

    if (tags.length === 0) {
        return <></>
    }

    return (
        <div className={`d-flex gap-1 ${props.onClick ? 'pointer' : ''} ${props.className}`} onClick={props.onClick}>
            {orderedTags.map(tagId => {
                const tag = allTagRecord[tagId];
                return <div
                    title={tag.text || ''}
                    style={{ width: '40px', height: '8px', backgroundColor: tag.color }}
                    key={tagId}
                    className='rounded'
                >
                </div>
            })}
        </div>
    )
}
